import React, { useEffect, useCallback, useState} from 'react';
import Colors from "components/Colors.js"
import {connect} from 'react-redux';
import {setKeyboardContext} from 'actions/index.js';
import CirklonEditor from "components/cirklon/CirklonEditor.js";
const colors = new Colors();

const ZCirklon = ({track, styling, zobject, setKeyboardContext}) => { 
    return (
        <div
          onMouseEnter={() => setKeyboardContext(zobject)}
          onClick={() => setKeyboardContext(zobject)}>
          {track && <CirklonEditor styling={zobject.attributes} track={track} color={colors.getColorForTrack(track)}/>}
        </div>
    );
}

const mapStateToProps = (state, props) => {
    if (!props.object || !props.object.sequencerEngine) {
        return {};
    }
    let track= props.object.sequencerEngine.getSelectedTrack();
    return {
        styling: state.zobject.objectStylings[props.zobject.id],
      track,
      id: track === undefined ? 0 :
          track.sample !== undefined && track.sample.getId() !== undefined ?
          track.sample.getId() : track.presetName || track.getName(),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setKeyboardContext: x => dispatch(setKeyboardContext(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZCirklon);
